import '../../App.css';
import { Bids } from '../../pages/providers/Bids';

import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel
} from "@material-tailwind/react";

import {
  Typography
} from "@material-tailwind/react";
import BidWinner from '../../components/BidWinner';
import { PendingBidsTab } from '../../components/PendingBidsTab';

function Dashboard() {
  const data = [
    {
      label: "Pending",
      value: "pendingBids",
      component: <Bids/>,
      className: "bid-card"
    },
    {
      label: "Placed Bids",
      value: "placedBids",
      component: <PendingBidsTab/>,
      className:"bid-list"
    }
  ];

  return (
    <div className="flex flex-col justify-center items-center">
      <BidWinner />
      <Typography variant="h3" color="blue-gray" className="mb-2 mt-2">
        Provider's Dashboard
      </Typography>
      
      <Tabs value="html" className="lg:min-w-full mt-5" activeClassName="bid-card">
        <TabsHeader>
          {data.map(({ label, value }) => (
            <Tab key={value} value={value} className="font-bold">
              {label}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>
          {data.map(({ value, component }) => (
            <TabPanel key={value} value={value}>
              {component}
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
  </div>
  );
}

export default Dashboard;
